import React, { Component } from 'react';
import './StackRankReportSummary.css';
// import RankingDistribution from '../../components/shared/RankingDistribution';
import Tooltip from '../shared/Tooltip';
import Event from '../../models/Event';
import _ from 'lodash';
import moment from 'moment';

// Import the stack rank data cache functions
import { storeStackRankData } from '../../features/ai-insights/components/prompts/stackRankPrompt';

import trophy1 from '../../images/trophy-1.svg';
import trophy2 from '../../images/trophy-2.svg';
import trophy3 from '../../images/trophy-3.svg';

export default class StackRankReportSummary extends Component {
  componentDidMount() {
    this.storeIdeasForAIInsights(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.event !== this.props.event || prevProps.ideas !== this.props.ideas) {
      this.storeIdeasForAIInsights(this.props);
    }
  }

  storeIdeasForAIInsights = ({ event, ideas }) => {
    if (event && event.id && Array.isArray(ideas) && ideas.length > 0) {
      storeStackRankData(event.id, ideas);
    }
  };

  getRankedIdeas = () => {
    let r = 0;
    let t = 0;
    let participantCount = 0;

    const ideas = (Array.isArray(this.props.ideas) ? this.props.ideas : [])
      .slice()
      .sort((a, b) => {
        if (a.total_rating === b.total_rating) {
          return 0;
        }
        return a.total_rating > b.total_rating ? 1 : -1;
      })
      .map((idea) => {
        if (idea.total_rating > t) {
          t = idea.total_rating;
          r++;
        }

        if (idea.total_rater > participantCount) {
          participantCount = idea.total_rater;
        }

        return {
          ...idea,
          _rank: r
        };
      });

    return { ideas, participantCount };
  };

  renderTrophy(rank) {
    if (this.props.isPdfRender) {
      return <div className="rank">{rank}</div>;
    }

    switch (rank) {
      case 1:
        return <img src={trophy1} alt={`Rank ${rank}`} className="rank trophy" width="30" height="30" />;
      case 2:
        return <img src={trophy2} alt={`Rank ${rank}`} className="rank trophy" width="30" height="30" />;
      case 3:
        return <img src={trophy3} alt={`Rank ${rank}`} className="rank trophy" width="30" height="30" />;
      default:
        return <div className="rank">{rank}th</div>;
    }
  }

  handleImageClick = ($event, photo) => {
    $event.preventDefault();

    const { onImageClick } = this.props;
    if (onImageClick) {
      onImageClick(photo);
    }
  };

  renderStatHeader = (label, tooltip) => {
    const content = <h4 className="font-weight-bold">{label}</h4>;
    if (this.props.isPdfRender) {
      return content;
    }
    return <Tooltip tooltip={tooltip}>{content}</Tooltip>;
  };

  renderOverviewLabel = (label, tooltip, iconName) => {
    if (this.props.isPdfRender) {
      return <span className="font-size-sm font-weight-bold">{label}</span>;
    }

    return (
      <Tooltip tooltip={tooltip}>
        <i className="material-icons font-size-xxl stats-icon">{iconName}</i>
      </Tooltip>
    );
  };

  formatStat = (value, digits) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue.toFixed(digits) : 'N/A';
  };

  render() {
    const { event } = this.props;
    const { ideas, participantCount } = this.getRankedIdeas();
    const commentCount = _.get(event, 'summary.comment_count', 0);
    const start = moment(Event.getStartTime(event));
    const end = moment(Event.getEndTime(event));
    const duration = end.diff(start, 'days');

    return (
      <div className="stack-rank-report-summary print">
        <div className="row">
          <div className="col-md-9">
            <div className="row stack-rank-idea-header">
              <div className="col-md-8">
                <h2 className="font-weight-bold font-size-lg">Overall Rankings</h2>
              </div>
              <div className="col-md-2 text-center pl-0 pr-0">
                {this.renderStatHeader(
                  'Avg Rank',
                  'Average (or Mean) rankings given by all participants. The lower the average, the higher the ranking.'
                )}
              </div>
              <div className="col-md-2 text-center">
                {this.renderStatHeader(
                  'Std Dev',
                  'Standard deviation shows how close the rankings are clustered around the average (or mean).'
                )}
              </div>
            </div>
            {ideas
              .map((idea, idx) => (
                <div key={idx} className="stack-rank-idea">
                  <div className="row stack-rank-idea-header">
                    <div className="col-md-8 d-inline-flex">
                      {this.renderTrophy(idea._rank)}
                      <div className="idea-title">
                        {idea.name}
                        {idea.media && idea.media.photo &&
                          <div onClick={$e => this.handleImageClick($e, idea.media.photo)}><img src={idea.media.photo} alt="idea" height="96" /></div>
                        }
                      </div>
                    </div>
                    <div className="col-md-2 text-center font-size-lg">
                      {this.formatStat(idea.avg_rating, 1)}
                    </div>
                    <div className="col-md-2 text-center font-size-lg">
                      {this.formatStat(idea.std_dev, 2)}
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-md-3 ranking-overview">
            <h2 className="stack-rank-idea-header font-weight-bold font-size-lg mb-20">Overview</h2>
            <table>
              <tbody>
                <tr>
                  <td>
                    {this.renderOverviewLabel('Participants', 'Number of people who participated in this session.', 'group')}
                  </td>
                  <td className="font-size-xl text-center align-text-bottom">
                    {participantCount}
                  </td>
                  <td className="font-size-sm align-text-bottom pl-1">
                    {`participant${participantCount > 1 ? 's' : ''}`}
                  </td>
                </tr>
                <tr>
                  <td>
                    {this.renderOverviewLabel('Comments', 'Number of comments in the session.', 'comments')}
                  </td>
                  <td className="font-size-xl text-center align-text-bottom">
                    {commentCount}
                  </td>
                  <td className="font-size-sm align-text-bottom pl-1">
                    {`comment${commentCount > 1 ? 's' : ''}`}
                  </td>
                </tr>
                <tr>
                  <td>
                    {this.renderOverviewLabel('Duration', 'Session duration', 'timelapse')}
                  </td>
                  <td className="font-size-xl text-center align-text-bottom">
                    {duration}
                  </td>
                  <td className="font-size-sm align-text-bottom pl-1">
                    days
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
